import { render, staticRenderFns } from "./TalentDetailsPreview.vue?vue&type=template&id=2c9583b8&scoped=true&"
import script from "./TalentDetailsPreview.vue?vue&type=script&lang=js&"
export * from "./TalentDetailsPreview.vue?vue&type=script&lang=js&"
import style0 from "./TalentDetailsPreview.vue?vue&type=style&index=0&id=2c9583b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9583b8",
  null
  
)

export default component.exports